<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            {{ "Add Equaliser Bar" | translate | async }}
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
    <div class="ttmodal__body">
        <form class="header-form">
            <mat-form-field class="header-form-full-width">
                <mat-select placeholder="{{'Type' | translate | async}}*" name="eqType_" [(ngModel)]="selectedToeOut" #eqType_="ngModel">
                    <mat-option [value]="1">
                        {{'Toe Out' | translate | async}}
                    </mat-option>
                    <mat-option [value]="2">
                        {{'Straight' | translate | async}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <mat-select placeholder="{{'Condition' | translate | async}}*" name="compCondition_" [(ngModel)]="selectedConditon" #compCondition_="ngModel">
                    <mat-option value="A">A</mat-option>
                    <mat-option value="B">B</mat-option>
                    <mat-option value="C">C</mat-option>
                    <mat-option value="X">X</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <mat-select placeholder="{{'Brand' | translate | async}}*" [(ngModel)]="selectedMakeId" name="make">
                    <mat-option *ngFor="let make of makeList" [value]="make.Id">{{make.Name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <input matInput type="number" placeholder="{{'Budget Life' | translate | async}}" [(ngModel)]="budgetLife" name="budgetLife">
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <input matInput type="number" placeholder="{{'CMU' | translate | async}}" [(ngModel)]="cmu" name="cmu">
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <input matInput type="number" placeholder="{{'Cost' | translate | async}}" [(ngModel)]="cost" name="cost">
            </mat-form-field>

            <div class="action-row">
                <a class="button"><span class="button__text" (click)="onNoClick()">{{'Cancel' | translate | async}}</span></a>
                <a class="button" [ngClass]="{ 'button--primary': isSaveEnabled, 'disabled': !isSaveEnabled }" (click)="isSaveEnabled && onSave()">
                    <i class="material-icons button__icon"></i>
                    <span class="button__text">{{'Save/Update' | translate | async}}</span>
                </a>
            </div>
        </form>
    </div>
</div>
